import { EnvMicroEmployee } from "lib-klab-core";

export const envEmployeeLocal: EnvMicroEmployee = {
  host: "",
  apiBasePath: "/ms-employee",
  useMocks: false,
};

export const envEmployeeDev: EnvMicroEmployee = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-employee",
  useMocks: false,
};

export const envEmployeeProd: EnvMicroEmployee = {
  host: "https://gatewayapi.erp.inclub.world",
  apiBasePath: "/ms-employee",
  useMocks: false,
};
